import React from "react";
import {
  ColumnContainer,
  ElementContainer,
} from "../../components/containers/styledComponents";
import { LegendCircle } from "../../components/visuals/styledComponents";
import { CompassParagraph } from "../../components/common/styledComponents";
import {
  graphPaletteV2,
  greyText,
  lightGreyOutline,
  lightGreyText,
} from "../../styles";
import { Checkbox } from "../../components/visuals/Checkbox";
import { formatReadable } from "../../utils/formattingUtils";
import styled from "styled-components";

interface MetricTreeNodeProps {
  title: string;
  isChecked: boolean;
  onClick: () => void;
  level?: number;
  isLeaf?: boolean;
  key?: string | number;
  data?: Record<string, string | number>;
}

const NodeContainer = styled(ElementContainer)<{
  level?: number;
  hasChildren?: boolean;
}>`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 8px;
  cursor: pointer;
  ${({ hasChildren }): string =>
    hasChildren ? `border-bottom: 1px solid ${lightGreyOutline};` : ""}
`;

export const MetricTreeNode: React.FC<MetricTreeNodeProps> = ({
  title,
  isChecked,
  onClick,
  level,
  isLeaf,
  data,
}) => {
  const fontSizeAdjustment = level ? level * -1 : 0;
  return (
    <NodeContainer
      onClick={(e): void => {
        e.stopPropagation();
        onClick();
      }}
      hasChildren={isLeaf}
    >
      <Checkbox size={18} checked={isChecked} />
      <ColumnContainer ai="flex-start" mt={1}>
        {
          <ElementContainer>
            <LegendCircle color={graphPaletteV2[(level || 0) + 1]} />

            <CompassParagraph
              mr={4}
              color={greyText}
              cursor="pointer"
              fontSize={16 + fontSizeAdjustment}
            >
              {formatReadable(title)}
            </CompassParagraph>
            {!isLeaf && (
              <CompassParagraph fontSize={11} color={lightGreyText}>
                {level ? `Level ${level}` : "Theme"}
              </CompassParagraph>
            )}
          </ElementContainer>
        }

        <CompassParagraph fontSize={11} color={lightGreyText} lh={1.4}>
          {(data && data.description) || ""}
        </CompassParagraph>
      </ColumnContainer>
    </NodeContainer>
  );
};
